const $ = window.jQuery;
const VTK_Mobile = window.VTK_Mobile;


class GQCustomQuestions {
    /**
     * initializer
     * @param {String}  _questionId                    -  question id
     * @param {String}  _ACElementEnableId             -  autocomplete element enable id
     * @param {String}  _ACElementId                   -  autocomplete element id
     * @param {String}  _formSubmitId                  -  form sumbit id
     * @param {String}  _ACElementPlaceholder          -  autocomplete placehoder
     * @param {String}  _otherFieldName                -  autocomplete other filed name
     * @param {String}  _hiddenDivId                   -  autocomplete hidden div id

     * @return Null
     */
  constructor(options) {
    this.isMultiStep = options.isMultiStep || false;
    return this;
  }

  init() {
    const self = this;
    self.initAutocomplete(220, 'where_to_enable', 'where_to', 'get_quotes_submit', 'postcode and suburb  e.g. 2000 - Sydney', 'search_where_to', 'hip_to_search_zip_suggests_ac');

    if (this.isMultiStep) {
      this.parent_cat_select = $('#search_practice2');
      this.child_cat_select = $('#drilldown_cat_id2');
    } else {
      this.parent_cat_select = $('#search_practice');
      this.child_cat_select = $('#drilldown_cat_id');
    }
        // add more changes event on parent and sub categories dropdown
    this.parent_cat_select.change(() => {
      setTimeout(() => { self.initAutocomplete(220, 'where_to_enable', 'where_to', 'get_quotes_submit', 'postcode and suburb  e.g. 2000 - Sydney', 'search_where_to', 'hip_to_search_zip_suggests_ac'); }, 100);
      setTimeout(() => { self.resetRemovalistsLayout(); }, 100);
      setTimeout(() => { self.changeRemovalistsLayout(); }, 100);
    });

    this.child_cat_select.change(() => {
      setTimeout(() => { self.initAutocomplete(220, 'where_to_enable', 'where_to', 'get_quotes_submit', 'postcode and suburb  e.g. 2000 - Sydney', 'search_where_to', 'hip_to_search_zip_suggests_ac'); }, 100);
      setTimeout(() => { self.resetRemovalistsLayout(); }, 100);
      setTimeout(() => { self.changeRemovalistsLayout(); }, 100);
    });
  }

  initAutocomplete(_questionId, _ACElementEnableId, _ACElementId, _formSubmitId, _ACElementPlaceholder, _otherFieldName, _hiddenDivId) {
    const question_id = _questionId;

        // hardcode, if get_quotes_question_{question_id} is existed
    const get_quotes_question = $(`input[name="get_quotes_question_${question_id}_0"]`);

    if (get_quotes_question.length) {
            // auto click on start by other button
      altStartBy('10', $('#start_by_10')[0]);

      const form_name = jQuery(`#${_formSubmitId}`).closest('form').attr('name');
      const form_element = jQuery(`#${_formSubmitId}`).closest('form');

      const where_to_placeholder = _ACElementPlaceholder;
            // change get quotes question id

      get_quotes_question.attr('id', _ACElementId);
      get_quotes_question.attr('placeholder', where_to_placeholder);

            // check _ACElementEnableId, _otherFieldName if existed already
      const ACElementEnable = form_element.find(`#${_ACElementEnableId}`);
      if (ACElementEnable.length == 0) {
        $('<input>').attr({
          type: 'hidden',
          id: _ACElementEnableId,
          value: '1'
        }).appendTo(form_element);
      }


      const otherField = form_element.find(`input[name="${_otherFieldName}"]`);
      if (otherField.length == 0) {
        $('<input>').attr({
          type: 'hidden',
          name: _otherFieldName,
          value: _ACElementId
        }).appendTo(form_element);
      }


      const where_to_enable = jQuery(`#${_ACElementEnableId}`).val();
      if (where_to_enable == '1') {
        jQuery(`#${_ACElementId}`).keyup(function () {
          jQuery(this).css({ color: '#333' });
        });
      }

      if (where_to_enable == '1') {
        const where_to_autocomplete = new VTKAutoComplete();
        const to_default_zip_value = jQuery(`#${_ACElementId}`).val();
        const to_default_zip_help = '';

        let where_autocomplete_fixed_width = 240;
        if (VTK_Mobile.isMobile()) {
                    // hack to match same with as #where field
          where_autocomplete_fixed_width = jQuery('#where').outerWidth();
        }

        where_to_autocomplete.init({
          queryFieldId: _ACElementId,
          queryFieldHelpInfo: to_default_zip_value,
          showQueryFieldHelpInfoOnFocus: true,
          initValue: to_default_zip_value,
          lookupURLPrefix: '/system/ajax_handlers/vtk.ac.search.zip.server.php?query=',
          formName: form_name,
          formAutoSubmit: false,
          FixedWidth: where_autocomplete_fixed_width,
          Alignment: 'left',
          PositionAdjust: true,
          otherFieldName: _otherFieldName,
          hiddenDivId: _hiddenDivId
        });

        where_to_autocomplete.vtc_ac_after_select_handler = function (value, text) {
          if (this.isMultiStep) {
            return false;
          }
          setTimeout(() => {
            jQuery(`#${_ACElementId}`).closest('li').next().find('.input_field').first().focus();
          }, 500);
        };

        where_to_autocomplete.vtc_ac_keyenter_handler = function () {
          return false;
        };

        where_to_autocomplete.vtc_ac_keytab_handler = function (value, text) {
          if (this.isMultiStep) {
            return false;
          }
          setTimeout(() => {
            jQuery(`#${_ACElementId}`).closest('li').next().find('.input_field').first().focus();
          }, 500);
        };
      }
    }
  }


    /**
     * change layout for removalists
     * @return Null
     */
  changeRemovalistsLayout() {
        // hardcode, if get_quotes_question_{question_id} is existed
    const get_quotes_question = $('input[name="get_quotes_question_220_0"]');

    if (get_quotes_question.length) {
            // display its wrapper
      if (this.isMultiStep) {
        $('#start_by_details_div').removeClass('hidden');
        $('#start_by_details_input_wrapper').removeClass('hidden');
        $('#start_by_div').addClass('hidden');
      } else {
        $('#start_by_details_input_wrapper').show().removeClass('hidden');
      }

            // change palceholder
      $('input[name="start_by_details"]').val('').attr('placeholder', 'dd/mm/yyyy');

            // change start by details label
      $('input[name="start_by_details"]').parent().prev().html('Ideal date');

            // change class
      $('input[name="start_by_details"]').parent().prev().removeClass().addClass('important alpha clear_left block mbt');

      if (!this.isMultiStep) {
                // hide start by li
        $('#start_by').parent().hide();
        const label = $('#where-label');
        if (label.length) {
          $(label).html('Where are you moving from?');
        } else {
                    // change where do you need the job done? label
          $('#where').prev().html('Where are you moving from?');
        }

        $('#get_quotes_questions').parent().insertAfter($('#where').parent());

        window.formValidation.settings.messages.w.required = "We couldn't figure out where are you moving from";
        window.formValidation.settings.messages.start_by_details.required = 'Please specify ideal date';
      }
    }
  }

    /**
     * reset layout for removalists
     * @return Null
     */
  resetRemovalistsLayout() {
        // display its wrapper
    if (this.isMultiStep) {
      $('#start_by_details_div').addClass('hidden');
      $('#start_by_details_input_wrapper').addClass('hidden');
      $('#start_by_div').removeClass('hidden');
    } else {
      $('#start_by_details_input_wrapper').hide().addClass('hidden');
    }

        // change palceholder
    $('input[name="start_by_details"]').val('other').attr('placeholder', '');

    if (!this.isMultiStep) {
            // change start by details label
      $('input[name="start_by_details"]').parent().prev().html('Please provide more details about your start date in the <label for="jobdesc" class="important">Description</label> box below');

            // change class
      $('input[name="start_by_details"]').parent().prev().removeClass().addClass('man alpha clear_left');

            // hide start by li
      $('#start_by').parent().show();
    }
        // change where do you need the job done? label
    $('#where').prev().html('Which suburb is the job in?');

        // hide error message in case it is displayed before
    $('#start_by_details_input_wrapper').next().hide();

    if (!this.isMultiStep) {
      window.formValidation.settings.messages.w.required = "We couldn't figure out where you want the job done";
      window.formValidation.settings.messages.start_by_details.required = 'Please specify start by details';
    }
  }
}

export default GQCustomQuestions;



// WEBPACK FOOTER //
// ./module_get_quotes/scripts/components/custom_questions.js